<template>
  <div>
    <div class="province" @click="goBack">{{ province }}</div>
    <div :id="id" class="o-echarts"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { cityMap } from '@/api/dataScreen'

export default {
  name: 'province',
  props: {
    province: {
      type: String,
      default: '',
    },
    provinceName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      id: 'echarts_' + new Date().getTime() + Math.floor(Math.random() * 1000),
    }
  },
  mounted() {
    this.cityMap()
  },
  methods: {
    goBack() {
      this.$emit('goBack')
    },
    async cityMap() {
      const { data: res } = await cityMap({
        provinceName: this.province,
      })
      this.$nextTick(() => {
        this.init(res)
      })
    },
    init(res) {
      let dataValue = []
      let provinceJSON = require('../../../../../assets/china/provinceData/' + this.provinceName)
      let dataList = provinceJSON.features.map(ele => {
        return {
          value: 0,
          name: ele.properties.name,
          cp: ele.properties.cp,
          houseCount: 0,
          publicBuildingCount: 0,
        }
      })
      const myChart = echarts.init(document.getElementById(this.id))
      echarts.registerMap(this.province, provinceJSON)

      if (res) {
        res.forEach(item => {
          const flag = dataList.findIndex(ele => ele.name === item.provinceName)
          if (flag !== -1) {
            dataList[flag].value = item.projectCount
            dataList[flag].houseCount = item.houseCount
            dataList[flag].publicBuildingCount = item.publicBuildingCount
            dataValue.push({ name: dataList[flag].name, value: dataList[flag].cp })
          }
        })
      }
      const option = {
        backgroundColor: 'transparent',
        tooltip: {
          trigger: 'item',
          formatter(params) {
            // params.data 就是series配置项中的data数据遍历
            const localValue = params.data ? params.data.value : 0
            const houseCount = params.data ? params.data.houseCount : 0
            const publicBuildingCount = params.data ? params.data.publicBuildingCount : 0
            const htmlStr = `
          <div style='padding:8px 100px 0 8px'>
            <div style='font-size:18px;color:#ffffff'> ${params.name}</div>
          <p style='text-align:left;margin-top:6px;color:#ffffff'>
            项目总数：${localValue || 0}${Number(localValue || 0) >= 10000 ? '万个' : '个'}
          </p>
          <p style='text-align:left;margin-top:6px;color:#ffffff'>
            住宅数量：${houseCount || 0}${Number(houseCount || 0) >= 10000 ? '万个' : '个'}
          </p>
          <p style='text-align:left;margin-top:6px;color:#ffffff'>
            公建数量：${publicBuildingCount || 0}${Number(publicBuildingCount || 0) >= 10000 ? '万个' : '个'}
          </p></div>
        `
            return htmlStr
          },
          backgroundColor: 'rgba(5, 24, 100, 0.72)',
          borderColor: 'rgba(136, 220, 253, 0.17)',
        },
        geo: [
          {
            map: this.province,
            aspectScale: 0.85,
            layoutCenter: ['45%', '50%'], //地图位置
            layoutSize: '100%',
            zlevel: 1,
            itemStyle: {
              normal: {
                areaColor: '#104597',
                borderColor: '#346ED1',
                borderWidth: 2,
              },
            },
            // 高亮状态下的多边形和标签样式。
            emphasis: {
              itemStyle: {
                areaColor: '#195ECA',
              },
              label: {
                color: '#fff',
              },
            },
            select: {
              itemStyle: {
                areaColor: '#195ECA',
              },
              label: {
                color: '#fff',
              },
            },
            label: {
              normal: {
                show: true,
                color: '#fff',
                fontWeight: '500',
              },
            },
          },
          {
            type: 'map',
            map: this.province,
            aspectScale: 0.85,
            layoutCenter: ['45%', '50%'], //地图位置
            layoutSize: '100%',
            roam: false,
            silent: true,
            label: {
              show: false,
            },
            itemStyle: {
              normal: {
                areaColor: '#104597',
                borderColor: '#104698',
                borderWidth: 8,
              },
              emphasis: { show: false },
            },
            select: { show: false },
            tooltip: {
              show: false,
            },
            zlevel: -1,
          },
        ],
        series: [
          {
            type: 'map',
            map: this.province,
            aspectScale: 0.85,
            layoutCenter: ['45%', '50%'], //地图位置
            layoutSize: '120%',
            geoIndex: 0,
            roam: false,
            zlevel: 1,
            data: dataList,
          },
          // {
          //   type: 'scatter',
          //   coordinateSystem: 'geo',
          //   data: dataValue,
          //   geoIndex: 0,
          //   silent: true, // 不影响鼠标事件
          //   symbolSize: [16, 18],
          //   symbolOffset: [0, -15],
          //   z: 999,
          //   tooltip: {
          //     show: false,
          //   },
          //   zlevel: 2,
          //   itemStyle: {
          //     color: '#00E5FF',
          //     opacity: 1,
          //   },
          //   symbol:
          //     'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAARCAYAAADtyJ2fAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAIdSURBVCiRdZDNS1RhFIef8773zrfj6KiNU9QIEbQIwq1BSIv+gFZuApetW7du31Yqog9s4SIoRA1aBLZzUREhWeRIaDSZH81l7r3ve1qYYtr8Vofzex4OHOFILm5GjSpm8ofoDS9EdW/vNJPO4w9DpfXDnOwP4xuda7+sm9hK3aUNn6aoKgIoZjjImDIsFFVmXteKzwDk6mZy67Nz17+7NBclaSRpGuNcivcOAGusGhsS2EwhCPKDNmifs8GDwBk71i8mH6j6NdJ228uuqMSoSVEV0ECFTAlbqtsgVwozhVhkTK5sJuNLob3tod1QekudNNeM41bT+Z+ISiMIqyfDsG87Y6MvwlYIpVErNwXgwrZ7+M5KAdWOAc6q1E556oD7avi2IroBCCK50VS3l3rtpAGoi7lX2XtU5IXdZaOrTSPry5bVFdE1hN8I0YDHDqR+CsAAzPXIq5FEWwgpEOOJBU1EiRE6QAK4Btqcr4aLByLAEP5pRcmzt/WCeMABHmBITamm5sk+fyDOVcKXI54YCAGrqPztAyBz2vnW87K8OSYC1FIzU1Z6UbIggQohSrbqpf+EmOnD7D/ibL/MNhwgUvCqWYUsIsUzSOtFWRa7igA1MdNFpeKFrIrk+zzVQeXRUU6OLgDO7/iFCIY7QjKo8vFtj0wcZY5dBKh5fz8rFEpKeQCm/sd0zfiOvr+8o/Pd+qBbYT13cwGfuvV/AKXd31tQBdbpAAAAAElFTkSuQmCC',
          // },
          {
            type: 'effectScatter',
            coordinateSystem: 'geo',
            data: dataValue,
            geoIndex: 0,
            symbolSize: 8,
            silent: true, // 不影响鼠标事件
            tooltip: {
              show: false,
            },
            zlevel: 2,
            encode: {
              value: 2,
            },
            showEffectOn: 'render',
            rippleEffect: {
              brushType: 'stroke',
              color: '#F9442F',
              period: 9,
              scale: 3,
            },
            hoverAnimation: true,
            itemStyle: {
              color: '#F9442F',
              shadowBlur: 2,
              shadowColor: '#333',
            },
          },
        ],
      }
      option && myChart.setOption(option)
      window.addEventListener('resize', () => {
        if (myChart && myChart.resize) {
          myChart.resize()
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../../assets/css/charts.scss';
.province {
  position: absolute;
  left: vw(10);
  top: vh(23);
  color: #fff;
  font-size: 1.042vw;
  font-weight: bold;
  text-align: left;
  cursor: pointer;
  z-index: 99999999;
}
.o-echarts {
  width: vw(763);
  height: vh(530);
  margin: auto;
}
</style>
